import React, { useState } from "react";
import { Form, Input, Button, Card, Row, Col, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import axios from "axios";
import { useLocation } from "react-router-dom";

const SetPassword = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("token") || "";
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    if (values.password !== values.confirm) {
      message.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await axios.post("/api/rbac/set-password", {
        token,
        password: values.password,
      });
      setDone(true);
      message.success("Password set. Please log in.");
      window.location.assign("/login");
    } catch (err) {
      message.error(err.response?.data?.message || err.message || "Failed");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <Row type="flex" justify="center" align="middle" style={{ minHeight: "100vh" }}>
        <Col sm={24} md={12} lg={8}>
          <Card>
            <p>Missing invite token. Please use the link from your invitation email.</p>
          </Card>
        </Col>
      </Row>
    );
  }

  if (done) {
    return (
      <Row type="flex" justify="center" align="middle" style={{ minHeight: "100vh" }}>
        <Col sm={24} md={12} lg={8}>
          <Card>
            <p>Password set successfully. Redirecting to login…</p>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row type="flex" justify="center" align="middle" style={{ minHeight: "100vh" }}>
      <Col sm={24} md={12} lg={8}>
        <Card>
          <h2>Set Your Password</h2>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="password"
              label="New password"
              rules={[{ required: true, min: 8, message: "At least 8 characters" }]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            <Form.Item
              name="confirm"
              label="Confirm password"
              rules={[{ required: true }]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Set password
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default SetPassword;
